import type { BlockTemplate } from '@zoomit/editor';
import type { ValueOf } from '@zoomit/primitives';

export const getBlockContainerType = (
  template?: ValueOf<BlockTemplate>,
): 'small' | 'standard' | 'full-width' => {
  if (!template) {
    return 'small';
  }

  switch (template) {
    case 'full_width':
      return 'full-width';
    case 'small':
    case 'ra-list-in-box-full-width':
    case 'ra-list-in-box-right':
    case 'ra-list-in-box-left':
    case 'ra-simple-list-full-width':
    case 'ra-simple-list-left':
    case 'ra-simple-list-right':
    case 'ra-image-list':
    case 'single_article1':
    case 'single_article3':
    case 'single_article4':
    case 'single_article_with_text':
    case 'text_image1':
    case 'text_image2':
    case 'text_image3':
    case 'text_image4':
    case 'text_image5':
    case 'text_image6':
    case 'keyword_right':
    case 'keyword_left':
    case 'keyword_full_width':
      return 'small';

    default:
      return 'standard';
  }
};

export const getBlockContainerFloat = (template?: string): 'right' | 'left' | 'normal' => {
  switch (template) {
    case 'ra-list-in-box-right':
    case 'ra-simple-list-right':
    case 'keyword_right':
      return 'right';
    case 'ra-list-in-box-left':
    case 'ra-simple-list-left':
    case 'keyword_left':
      return 'left';
    default:
      return 'normal';
  }
};
